import extractDataFromMap from "../../../utils/ExtractDataFromMap";
import { format } from "date-fns";

const PrintableTableContentRow = (props) => {
  const { settings, data } = props;

  const classStyleStart = " border-zinc-300 border border-t-0  px-2 pt-2 pb-1 ";
  const classStyleMiddleEnd =
    " border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 ";

  return (
    <tr className="row-start-start w-full text-sm text-slate-700 !items-stretch">
      {settings.map((setting, index) => {
        const randomKey = Math.random().toString(5).substring(2) + index;

        let contentTxt = "";

        const value = extractDataFromMap({
          key: setting.field,
          map: data,
        });

        if (setting.type === "number") {
          contentTxt = (value ?? 0).toLocaleString("id-ID", {
            maximumFractionDigits: setting.maxFraction ?? 2,
            minimumFractionDigits: setting.minFraction ?? 0,
          });
        } else if (setting.type === "date") {
          if (value != null) {
            const dateObject = new Date(value);
            contentTxt = isNaN(dateObject.getTime())
              ? "-"
              : format(dateObject, setting.format ?? "dd/MM/yyyy");
          }
        } else if (setting.type === "datetime") {
          if (value != null) {
            const dateObject = new Date(value);
            contentTxt = isNaN(dateObject.getTime())
              ? "-"
              : format(dateObject, "dd/MM/yyyy HH:mm");
          }
        } else if (setting.type === "currency") {
          contentTxt = new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0,
          }).format(value || 0);
        } else if (setting.type === "percent") {
          contentTxt = `${(value ?? 0).toLocaleString("id-ID", {
            maximumFractionDigits: setting.maxFraction ?? 2,
            minimumFractionDigits: setting.minFraction ?? 0,
          })}%`;
        } else {
          contentTxt = value;
        }

        const cellContent = setting.wrap ? (
          <div className="w-full min-w-0 break-words">{contentTxt}</div>
        ) : (
          contentTxt
        );

        return (
          <td
            key={randomKey}
            className={`${index === 0 ? classStyleStart : classStyleMiddleEnd} ${setting.width} ${setting.layout} whitespace-pre-line ${setting.wrap ? "min-w-0" : ""}`}
          >
            {setting.onClick ? (
              <button
                type="button"
                className="text-left text-blue-600 hover:underline print:no-underline print:text-inherit"
                onClick={() => setting.onClick(data)}
              >
                {cellContent}
              </button>
            ) : (
              cellContent
            )}
          </td>
        );
      })}
    </tr>
  );
};

export default PrintableTableContentRow;
